/**
 * Configuration PDF download helper
 *
 * @package
 */

/**
 * Request the configuration PDF and hand it to the browser as a download.
 *
 * @param {Object}      options                   - Request options.
 * @param {number|null} options.selectedBaseModel - Selected base model product ID.
 * @param {Array}       options.selectedProducts  - Selected product IDs.
 * @param {number|null} options.vehicleConfigId   - Vehicle configuration post ID.
 * @param {string|null} options.shareableCode     - Existing shareable code, if any.
 * @param {string}      options.vatMode           - 'including' or 'excluding'.
 * @param {Object}      options.quantities        - Product ID => quantity.
 * @return {Promise<void>} Resolves once the download has started.
 */
export const downloadConfigurationPdf = async ( {
	selectedBaseModel,
	selectedProducts,
	vehicleConfigId,
	shareableCode,
	vatMode,
	quantities = {},
} ) => {
	const response = await fetch( `${ atConfigurator.apiUrl }pdf`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-WP-Nonce': atConfigurator.nonce,
		},
		body: JSON.stringify( {
			base_model: selectedBaseModel > 0 ? selectedBaseModel : null,
			products: selectedProducts || [],
			vehicle_config_id: vehicleConfigId || null,
			shareable_code: shareableCode || null,
			page_url: window.location.origin + window.location.pathname,
			vat_mode: vatMode || 'including',
			quantities,
		} ),
	} );

	if ( ! response.ok ) {
		throw new Error( 'PDF generation failed' );
	}

	const blob = await response.blob();
	const url = window.URL.createObjectURL( blob );
	const link = document.createElement( 'a' );
	link.href = url;
	link.download = `vehicle-config-${ new Date().toISOString().split( 'T' )[ 0 ] }.pdf`;
	document.body.appendChild( link );
	link.click();
	window.URL.revokeObjectURL( url );
	document.body.removeChild( link );
};
